var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMybookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3470)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9111 16L27.4424 33.5L32.9111 45.0698L44.7715 51V33.5L48.3604 16H32.9111Z",
    fill: "#E60000",
    fillOpacity: 0.81
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6396 16C22.6607 16 21.0508 17.6099 21.0508 19.5889V51L32.9111 45.0698V16H24.6396Z",
    fill: "#FF7705",
    fillOpacity: 0.88
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3604 16C46.3783 16 44.7715 17.6068 44.7715 19.5889V33.5H51.9492V19.5889C51.9492 17.6068 50.3424 16 48.3604 16Z",
    fill: "url(#paint1_linear_4819_3470)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3470",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4819_3470",
    x1: 48.3604,
    y1: 16,
    x2: 48.3604,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF1EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMybookmark);
export default __webpack_public_path__ + "static/media/MYBOOKMARK.cfea1e8e34e529093f33b2d417172251.svg";
export { ForwardRef as ReactComponent };